import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  InventoryExtendedReportCalendarLimit,
  InventoryExtendedReportCalendarRange,
} from '@inventory/constants/inventory-constants';
import { ExtendedCostReportEvent } from '@inventory/models/inventory-extended-cost-report.model';
import { PlatformEnum } from '@panamax/app-state';
import { MultiSelectMode } from '@shared/helpers/calendar.helpers';

@Component({
  selector: 'app-extended-cost-report-modal',
  templateUrl: './extended-cost-report-modal.component.html',
  styleUrls: ['./extended-cost-report-modal.component.scss'],
})
export class ExtendedCostReportModalComponent {
  @Input() platformType: PlatformEnum;
  @Output()
  submitEvent: EventEmitter<ExtendedCostReportEvent> = new EventEmitter();
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter();
  platformEnum = PlatformEnum;
  dateRange: string[] = [];
  limit = InventoryExtendedReportCalendarLimit;
  range = InventoryExtendedReportCalendarRange;
  selectMode = MultiSelectMode.Limited;

  constructor() {}

  dismiss() {
    this.dismissEvent.emit();
  }

  submit() {
    this.submitEvent.emit({ dateRange: this.dateRange });
  }

  handleRangeSelection(range: string[]) {
    this.dateRange = range;
  }
}
